<template>
  <div class="preview-rewards-card">
    <div class="preview-rewards-card-list">
      <v-flex
        v-for="(item, index) in items"
        :key="index"
      >
        <div
          v-if="item.quantity > 0"
          class="content"
        >
          <div class="first-item">
            <img
              :src="item.img"
              width="30"
              class="mr-2"
            >
            <h4 class="mr-2">
              {{ item.quantity }}x {{ item.title }}
            </h4>
          </div>
          <span class="trigger">
            {{ item.trigger }}
          </span>
        </div>
      </v-flex>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PreviewRewards',

  props: {
    items: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style lang="stylus">
.preview-rewards-card
  padding: 0 10px;
  .content
    display: flex;
    justify-content: space-between;
    padding: 15px 15px;
    border-bottom: 1px solid #CCCCCC;
    margin: 15px 0;
    .first-item
      display: flex;
      justify-content: center;
      align-items: center;
</style>
